import { css } from "styled-components"

import { api } from "@services/api"
import {
  HomeRounded,
  PostAddRounded,
  AccountCircleOutlined,
  SupervisedUserCircleOutlined,
  QuestionAnswerOutlined,
} from "@mui/icons-material"

import { DASHBOARD_ROUTE } from "@features/dashboard"
import { ADD_VEHICLE_ROUTE } from "@features/vehicle"
import {
  REGISTER_VEHICLE_ROUTE,
  COMPREHENSIVE_INSURANCE_ROUTE,
  VEHICLE_TRACKING_ROUTE,
} from "@features/process-papers"
import { DRIVERS_LICENSE_ROUTE } from "@features/drivers-license"
import { CART_ROUTE } from "@features/cart"
import { ORDERS_ROUTE } from "@features/orders"
import { ESTIMATE_PRICE_ROUTE } from "@features/price-estimate"
import { FAQS_ROUTE } from "@features/faqs"
import {
  ADMIN_ROUTE,
  EXTRA_PAYMENT_ROUTE,
  OFFLINE_PAYMENT_ROUTE,
  PROCESS_ORDERS_ROUTE,
  APPROVE_VEHICLES_ROUTE,
  UPDATE_PROFILE_ROUTE,
  SEND_EMAIL_ROUTE,
  SEND_DEVICE_NOTIFICATIONS_ROUTE,
  CREDIT_ACCOUNT_ROUTE,
  REMINDER_ROUTE,
  SEND_MODAL_NOTIFICATION_ROUTE,
  ADMIN_DASHBOARD_ROUTE,
  TENANT_ORDERS_ROUTE,
  EXPENSES_ROUTE,
} from "@features/admin"

import {
  FIN_API_DASHBOARD,
  FIN_API_DOCS_ROUTE,
  FIN_API_SETTINGS_ROUTE,
  FIN_API_TRANSACTIONS_LIST_ROUTE,
} from "@features/finapi"
import { REFER_AND_EARN_ROUTE, EDIT_PROFILE_ROUTE } from "@features/profile"
import { isNative, sendMessageToNative } from "../../../native/utils"

export const SAFE_AREA_VIEW_PADDING = 0 // 56
export const NAVBAR_HEIGHT = 48
export const TOP_PADDING_WITH_SAFE_VIEW = 24
export const TABBAR_HEIGHT = 64
export const SIDEBAR_WIDTH = 264

const SUPER_ADMIN = ["admin"]
const ADMIN = ["admin", "processor"]

export const userMenuList = [
  {
    menu: "0",
    label: "Home",
    icon: <HomeRounded />,
    open: false,
    submenus: [
      { id: 0, title: "Dashboard", route: DASHBOARD_ROUTE },
      { id: 1, title: "Estimate Prices", route: ESTIMATE_PRICE_ROUTE },
      { id: 2, title: "Freq. Asked Questions", route: FAQS_ROUTE },
    ],
  },
  {
    menu: "1",
    label: "Processes",
    icon: <PostAddRounded />,
    open: false,
    submenus: [
      { id: 0, title: "Add a Vehicle", route: ADD_VEHICLE_ROUTE },
      {
        id: 1,
        title: "New Vehicle Registration",
        route: REGISTER_VEHICLE_ROUTE,
      },
      {
        id: 2,
        title: "Driver’s Licence",
        route: DRIVERS_LICENSE_ROUTE,
      },
      {
        id: 3,
        title: "Comprehensive Insurance",
        route: COMPREHENSIVE_INSURANCE_ROUTE,
        enabled: true,
      },
      {
        id: 4,
        title: "Vehicle Tracking",
        route: VEHICLE_TRACKING_ROUTE,
        enabled: true,
      },
    ],
  },
  {
    menu: "2",
    label: "Chat",
    icon: <QuestionAnswerOutlined />,
    open: false,
    submenus: [],
  },

  {
    menu: "3",
    label: "Profile",
    icon: <AccountCircleOutlined />,
    open: false,
    submenus: [
      { id: 0, title: "My Cart", route: CART_ROUTE },
      { id: 1, title: "Orders", route: ORDERS_ROUTE },
      { id: 2, title: "Refer & Earn", route: REFER_AND_EARN_ROUTE },
      {
        id: 3,
        title: "Settings",
        route: EDIT_PROFILE_ROUTE,
      },
      {
        id: 4,
        title: "Change Password",
        route: "change-password",
      },
      { id: 5, title: "Log out", route: "log-out" },
    ],
  },
]
export const finapiMenuList = [
  {
    menu: "0",
    label: "Home",
    icon: <HomeRounded />,
    open: false,
    submenus: [
      { id: 0, title: "Dashboard", route: FIN_API_DASHBOARD },
      { id: 1, title: "API Docs", route: FIN_API_DOCS_ROUTE },
      {
        id: 2,
        title: "Transactions",
        route: FIN_API_TRANSACTIONS_LIST_ROUTE,
      },
      { id: 3, title: "Settings", route: FIN_API_SETTINGS_ROUTE },
      { id: 4, title: "Log out", route: "log-out" },
    ],
  },
]

export const adminMenuList = {
  menu: "4",
  label: "Admin",
  icon: <SupervisedUserCircleOutlined />,
  open: false,
  submenus: [
    {
      id: 0,
      title: "Process Orders",
      route: PROCESS_ORDERS_ROUTE,
      roles: ADMIN,
    },
    {
      id: 1,
      title: "Offline Payments",
      route: OFFLINE_PAYMENT_ROUTE,
      roles: ADMIN,
    },
    {
      id: 2,
      title: "Send reminder messages",
      route: REMINDER_ROUTE,
      roles: ADMIN,
    },
    {
      id: 3,
      title: "Approve Vehicles",
      route: APPROVE_VEHICLES_ROUTE,
      roles: ADMIN,
    },
    {
      id: 4,
      title: "Create Extra payments",
      route: EXTRA_PAYMENT_ROUTE,
      roles: ADMIN,
    },
    {
      id: 5,
      title: "Send payment request",
      route: EXPENSES_ROUTE,
      roles: ADMIN,
    },
    { id: 6, title: "All Vehicles", route: ADMIN_ROUTE, roles: ADMIN },
    {
      id: 7,
      title: "Update user profile",
      route: UPDATE_PROFILE_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 8,
      title: "Send emails",
      route: SEND_EMAIL_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 13,
      title: "Send device notifications",
      route: SEND_DEVICE_NOTIFICATIONS_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 9,
      title: "Credit user account",
      route: CREDIT_ACCOUNT_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 10,
      title: "Create Modal Notification",
      route: SEND_MODAL_NOTIFICATION_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 11,
      title: "Admin Dashboard",
      route: ADMIN_DASHBOARD_ROUTE,
      roles: SUPER_ADMIN,
    },
    {
      id: 12,
      title: "All Tenant Transactions",
      route: TENANT_ORDERS_ROUTE,
      roles: SUPER_ADMIN,
    },
  ],
}

export const handleNavigation = (
  dispatch: any,
  route: string,
  navigate: (val: string) => void,
  jumpTo: (val: string) => void,
  setAuth: (val: any) => void,
) => {
  if (route === "log-out") {
    // signOut(auth)
    setAuth({ user: null, loading: true })
    dispatch((api.endpoints as any).signOut.initiate({}))
      .then(() => {
        setAuth({ user: null, loading: false })
        navigate("/")
      })
      .catch((error: any) => {
        console.warn("An error happened.", error)
      })
  } else {
    jumpTo(route)
  }
}

export const slideUpProps = css`
  @keyframes slideIn {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  animation: slideIn 0.2s ease-in;
`

export const slideLeftProps = css`
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
  animation: slideIn 0.2s ease-out;
`

export const slideOutProps = css`
  @keyframes slideOut {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }
  animation: slideIn 0.5s ease-out;
`

interface OpenWhatsAppProps {
  phone?: string
  text?: string
  name?: string
  email?: string
}

export const openWhatsAppChat = ({
  phone = "2348166944267",
  text = "",
  name = "a customer",
  email = "",
}: OpenWhatsAppProps) => {
  const emailString = email ? ` (${email})` : ""
  const textToUse =
    text || `Hello, it's ${name} ${emailString} from the CarPaddy app:`

  const url = encodeURI(
    `https://api.whatsapp.com/send?phone=${phone}&text=${textToUse}`,
  )

  if (isNative) {
    sendMessageToNative({
      action: "url",
      payload: url,
    })
  } else {
    window.open(url, "_blank", "noopener,noreferrer")
  }
}
